module.exports = __webpack_public_path__ + "static/media/123-Beschreibung.91012d52.jpg";